import { Modal } from '@mui/material';
import React from 'react';
import {
    CloseButton,
    Image,
    WrapperModal,
} from '../../../../styled-components';
import { Icon } from '@iconify/react';
import { Text } from '../../../common/Texts';
import EnrollSuccess from '../../../../assets/media/aden/high-five.png';
import Error from '../../../../assets/media/aden/error.png';

const SuccessfulUploadModal = (props) => {
    const { open, handleCloseModal, messageError, state } = props;
    const isError =
        state === 'rechazada' || state === 'rechazado' ? true : false;
    const isAccepted =
        state === 'aceptada' || state === 'aceptado' ? true : false;
    const isRejected =
        state === 'rechazada' || state === 'rechazado' ? true : false;
    const isPending =
        state === 'pendiente aprobación' ||
        state === 'pendiente de aprobación' ||
        'pendiente'
            ? true
            : false;
    return (
        <Modal onClose={handleCloseModal} open={open}>
            <WrapperModal
                widthModal={messageError ? '500px' : 'max-content'}
                maxHeightModal="max-content"
                gapModal="1rem"
                topModal="50%"
                leftModal="50%"
            >
                <CloseButton onClick={handleCloseModal}>
                    <Icon icon="iconoir:cancel" width="24px" height="24px" />
                </CloseButton>
                <Image
                    src={!isError ? EnrollSuccess : Error}
                    width={'250px'}
                    height={'250px'}
                />
                {isAccepted && (
                    <Text
                        fontSize="20px"
                        fontWeight={700}
                        color="#616161"
                        textAlign="center"
                        lineHeight="24px"
                    >
                        ¡Excelente! Su documento ha sido aceptado.
                    </Text>
                )}

                {isRejected && (
                    <>
                        <Text
                            fontSize="20px"
                            fontWeight={700}
                            color="#B31D15"
                            textAlign="center"
                            lineHeight="24px"
                        >
                            ¡Tu documento ha sido rechazado!
                        </Text>
                        <Text
                            fontSize="16px"
                            fontWeight={400}
                            color="#222222"
                            textAlign="center"
                            lineHeight="24px"
                        >
                            {messageError}
                        </Text>
                        <Text
                            fontSize="16px"
                            fontWeight={700}
                            color="#222222"
                            textAlign="center"
                            lineHeight="24px"
                        >
                            Por favor, carga un documento vigente e intenta
                            nuevamente.
                        </Text>
                    </>
                )}

                {isPending && (
                    <Text
                        fontSize="20px"
                        fontWeight={700}
                        color="#616161"
                        textAlign="center"
                        lineHeight="24px"
                    >
                        ¡Excelente! Pronto estarás recibiendo novedades
                        {<br></br>}
                        sobre el estado de la documentación.
                        {<br></br>}
                    </Text>
                )}
            </WrapperModal>
        </Modal>
    );
};

export default SuccessfulUploadModal;
